module.exports = __webpack_public_path__ + "img/howitworks_hero.5a57460c.jpg";